import React from 'react';
import HostingerStyleServiceTemplate from '../../components/HostingerStyleServiceTemplate';
import FounderInsight from '../../components/FounderInsight';
import { FaCut, FaMobileAlt, FaSearch, FaUsers, FaCode, FaRocket, FaMapMarkerAlt, FaImage, FaCalendarAlt } from 'react-icons/fa';

const WebPeluqueriaPage = () => {
  // Keyword principal: "página web barata"
  const mainKeyword = "página web barata";
  
  // Enlaces internos relacionados
  const relatedLinks = [
    { url: "/servicios/diseno-web-autonomos", text: "Página web barata para autónomos" },
    { url: "/servicios/diseno-web-pymes", text: "Página web barata para PYMES" },
    { url: "/servicios/landing-pages", text: "Landing pages económicas" },
    { url: "/precios", text: "Ver todos nuestros precios" },
    { url: "/proceso", text: "Conoce nuestro proceso de trabajo" }
  ];
  
  // Lista de beneficios adaptados al buyer persona José
  const benefits = [
    {
      title: "Consigue más clientes mientras estás cortando",
      description: "Tu web trabaja 24/7, captando clientes potenciales incluso cuando estás ocupado con otros clientes. Recibe consultas y solicitudes a cualquier hora."
    },
    {
      title: "Diferénciate de otras peluquerías",
      description: "El 65% de las peluquerías aún no tienen presencia online profesional. Destaca frente a tu competencia con una web moderna y funcional."
    },
    {
      title: "Muestra tu talento con un portfolio visual",
      description: "Un portfolio de trabajos realizados genera confianza instantánea. Las imágenes de antes/después incrementan un 40% las conversiones."
    },
    {
      title: "Posiciónate localmente en Google",
      description: "Aparece cuando potenciales clientes buscan 'peluquería en [tu barrio/ciudad]'. El 92% de las búsquedas de servicios locales incluyen consultas de proximidad."
    },
    {
      title: "Ahorra tiempo en consultas básicas",
      description: "Precios, horarios, ubicación y servicios accesibles 24/7. Reduce llamadas informativas y céntrate en dar servicio a tus clientes presenciales."
    },
    {
      title: "Retorno de inversión inmediato",
      description: "Con solo 2-3 nuevos clientes mensuales que lleguen por la web, recuperas la inversión en el primer trimestre. Después todo son beneficios."
    }
  ];
  
  // Características adaptadas al buyer persona José
  const features = [
    {
      icon: <FaCut />,
      title: "Catálogo visual de servicios",
      description: "Presentación atractiva de tus servicios con precios actualizables. Secciones para cortes, coloración, tratamientos y servicios especiales."
    },
    {
      icon: <FaMobileAlt />,
      title: "Diseño 100% adaptado a móviles",
      description: "El 78% de las búsquedas de peluquerías se hacen desde móvil. Tu web se verá perfecta en cualquier dispositivo, aumentando las conversiones."
    },
    {
      icon: <FaImage />,
      title: "Galería de trabajos realizados",
      description: "Muestra tus mejores creaciones con una galería profesional. Organiza por categorías (cortes, color, tratamientos) para inspirar a tus clientes."
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Optimización local avanzada",
      description: "Configuración para Google Maps y Google Business Profile. Destaca cuando busquen peluquerías cercanas con horarios e información actualizada."
    },
    {
      icon: <FaCut />,
      title: "Presentación de estilistas",
      description: "Sección para presentar a tu equipo con su especialidad y experiencia. Genera confianza y permite que los clientes elijan a su profesional favorito."
    },
    {
      icon: <FaSearch />,
      title: "SEO específico para peluquerías",
      description: "Posicionamiento para términos como 'peluquería [especialidad] en [tu zona]'. Optimización de contenidos para atraer a tu cliente ideal."
    }
  ];
  
  // Planes de precios adaptados
  const plans = [
    {
      title: 'Web Peluquería Básica',
      price: 200,
      period: 'pago único',
      description: 'Para peluquerías que necesitan una web sencilla pero profesional para comenzar su presencia online.',
      features: [
        { text: 'Hasta 5 páginas', included: true },
        { text: 'Adaptada a móviles', included: true },
        { text: 'Catálogo básico de servicios', included: true },
        { text: 'Presentación del negocio', included: true },
        { text: 'Galería de trabajos', included: true },
        { text: 'Integración redes sociales', included: true },
        { text: 'Formulario de contacto', included: true },
        { text: 'SEO básico local', included: true },
        { text: 'Sistema de citas online', included: false },
        { text: 'Mantenimiento y hosting 20€/mes', included: true },
      ],
      buttonText: 'Solicitar presupuesto gratis',
      buttonLink: '/reserva?plan=peluqueria-basica',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Peluquería Profesional',
      price: 300,
      period: 'pago único',
      description: 'La más elegida. Web completa con todas las funcionalidades para peluquerías que quieren crecer.',
      features: [
        { text: 'Entre 5-10 páginas', included: true },
        { text: 'Adaptada a todos los dispositivos', included: true },
        { text: 'Catálogo completo con imágenes', included: true },
        { text: 'Presentación del equipo profesional', included: true },
        { text: 'Galería avanzada de trabajos', included: true },
        { text: 'Integración con redes sociales', included: true },
        { text: 'Blog para tendencias y consejos', included: true },
        { text: 'Optimización SEO local', included: true },
        { text: 'Sistema de citas online básico*', included: false },
        { text: 'Configuración Google Business Profile', included: true },
      ],
      isPopular: true,
      buttonText: 'Solicitar presupuesto gratis',
      buttonLink: '/reserva?plan=peluqueria-pro',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Peluquería Premium',
      price: 400,
      period: 'pago único',
      description: 'Solución completa para salones que buscan una experiencia digital premium para sus clientes.',
      features: [
        { text: 'Entre 10-15 páginas', included: true },
        { text: 'Diseño exclusivo personalizado', included: true },
        { text: 'Catálogo premium con filtros', included: true },
        { text: 'Venta de productos online', included: true },
        { text: 'Galería profesional con categorías', included: true },
        { text: 'Multiidioma (2 idiomas)', included: true },
        { text: 'Blog con contenido inicial', included: true },
        { text: 'Estrategia SEO completa', included: true },
        { text: 'Sistema de citas online avanzado*', included: false },
        { text: 'Marketing digital inicial', included: true },
      ],
      buttonText: 'Solicitar presupuesto gratis',
      buttonLink: '/reserva?plan=peluqueria-premium',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    }
  ];
  
  // Proceso paso a paso simplificado
  const processSteps = [
    {
      number: 1,
      title: "Análisis y planificación",
      description: "Estudiamos tu peluquería, estilo y servicios. Planificamos una web que refleje la esencia de tu salón y conecte con tus clientes ideales.",
      icon: <FaUsers />
    },
    {
      number: 2,
      title: "Diseño y desarrollo",
      description: "Creamos una web con diseño atractivo y profesional. Implementamos todas las secciones y funcionalidades necesarias para tu peluquería.",
      icon: <FaCode />
    },
    {
      number: 3,
      title: "Lanzamiento y posicionamiento",
      description: "Publicamos tu web, te formamos en su uso y configuramos estrategias SEO local para que te encuentren los clientes de tu zona.",
      icon: <FaRocket />
    }
  ];
  
  // Comparativa directa
  const comparisonItems = [
    {
      label: "Diseño específico para peluquerías",
      us: true,
      others: false
    },
    {
      label: "Optimización SEO local incluida",
      us: true,
      others: false
    },
    {
      label: "Galería optimizada para trabajos de peluquería",
      us: true,
      others: false
    },
    {
      label: "Actualización sencilla de precios y servicios",
      us: true,
      others: false
    },
    {
      label: "Presentación profesional del equipo",
      us: true,
      others: false
    },
    {
      label: "Formación en actualización de contenidos",
      us: true,
      others: false
    }
  ];
  
  // Testimonio real para el sector
  const testimonial = {
    text: "Antes dependía exclusivamente del boca a boca y las redes sociales. Desde que lancé mi web profesional, estoy captando un tipo de cliente diferente, que valora más la calidad y está dispuesto a pagar por servicios premium. La web me ha permitido mostrar claramente mis especialidades y el nivel de mis trabajos. Lo que más me gusta es que puedo actualizar yo misma la galería añadiendo fotos de mis nuevos trabajos. Ha sido una inversión que se amortizó en apenas un mes con los nuevos clientes.",
    author: "Laura Martínez",
    position: "Directora",
    company: "Salón de Belleza Laura",
    avatar: "/servicios/testimonios/peluqueria.webp"
  };
  
  const founderMessage = "En el sector de la peluquería, la imagen lo es todo. Diseñamos webs que destacan el talento visual del estilista mediante galerías de impacto y presentaciones de servicios claras. El cliente típico de peluquería necesita ver ejemplos reales antes de decidirse, y una buena web debe inspirar esa confianza inicial.";
  
  // FAQs específicas para web de peluquerías
  const faqs = [
    {
      question: "¿Por qué necesito una web profesional para mi peluquería?",
      answer: "Una web profesional es esencial para las peluquerías modernas por varios motivos clave: 1) El 83% de los clientes potenciales buscan peluquerías online antes de decidir dónde ir; 2) Muestra tus trabajos y estilo, permitiendo que los clientes vean tu nivel antes de visitarte; 3) Proporciona información básica (horarios, ubicación, precios) 24/7, reduciendo llamadas informativas; 4) Te posiciona en Google Maps y búsquedas locales, fundamental para captar clientes de proximidad; 5) Permite diferenciarte de la competencia destacando tus especialidades; 6) Facilita la captación de un perfil de cliente de mayor valor, interesado en servicios premium; 7) Complementa y potencia tus redes sociales, dirigiendo el tráfico hacia información más completa. Según estudios del sector, las peluquerías con presencia web profesional incrementan sus ingresos entre un 15-25% en el primer año, principalmente por captación de nuevos clientes y aumento del ticket medio.",
      category: "Beneficios"
    },
    {
      question: "¿Cómo se mostrarán mis trabajos y servicios en la web?",
      answer: "Tus trabajos y servicios se presentarán con un enfoque visual y profesional: 1) Galería de trabajos organizados por categorías (cortes, coloración, tratamientos, peinados), con posibilidad de mostrar antes/después; 2) Catálogo de servicios estructurado, con descripción, tiempo aproximado y rango de precios por servicio; 3) Imágenes optimizadas para carga rápida sin pérdida de calidad; 4) Sección destacada en la página de inicio con tus mejores creaciones; 5) Presentación del equipo vinculada a sus especialidades y trabajos; 6) Posibilidad de incluir videos breves de transformaciones destacadas; 7) Testimonios de clientes junto a imágenes de los resultados. Además, te formaremos para que puedas actualizar fácilmente la galería desde tu móvil o tablet, añadiendo nuevos trabajos cuando los realices. La presentación visual es crucial en el sector de la peluquería, por eso prestamos especial atención a la optimización de imágenes y la organización del contenido visual.",
      category: "Contenidos"
    },
    {
      question: "¿Incluís un sistema de citas online?",
      answer: "Ofrecemos varias opciones para la gestión de citas online, que se presupuestan por separado al no estar incluidas en los planes básicos: 1) Sistema básico de solicitud de citas (desde 50€) - El cliente solicita hora y servicio mediante un formulario, y tú confirmas manualmente; 2) Sistema intermedio con calendario (desde 150€) - Integración con Google Calendar o similar, donde el cliente ve disponibilidad real y reserva directamente; 3) Sistema avanzado especializado (desde 300€) - Plataforma completa con gestión de estilistas, servicios con duraciones específicas, recordatorios automáticos, etc. Estos sistemas son complementos opcionales a la web, no incluidos en los precios base, ya que cada peluquería tiene necesidades diferentes. También podemos integrar plataformas externas como Treatwell, Booksy, o tu sistema actual si ya utilizas alguno. La implementación del sistema de citas requiere configuración específica según tu forma de trabajo, por lo que se presupuesta individualmente tras analizar tus necesidades exactas.",
      category: "Funcionalidades"
    },
    {
      question: "¿Cuántas páginas incluye cada plan?",
      answer: "Cada plan incluye un número limitado de páginas: 1) El plan Básico (200€) incluye hasta 5 páginas principales: inicio, servicios, galería de trabajos, equipo y contacto; 2) El plan Profesional (300€) permite entre 5-10 páginas, añadiendo secciones como blog, páginas específicas por tipo de servicio (corte, color, tratamientos), o página detallada para cada estilista; 3) El plan Premium (400€) permite entre 10-15 páginas, pudiendo añadir tienda online básica, páginas multiidioma, secciones especializadas, etc. Si necesitas más páginas de las incluidas en tu plan, estas tienen un coste adicional de 40€ por página. Para webs con más de 15 páginas, recomendamos solicitar un presupuesto personalizado. La mayoría de peluquerías obtienen excelentes resultados con las páginas incluidas en los planes estándar, ya que lo importante es la calidad del contenido y la organización de la información, no la cantidad de páginas.",
      category: "Planes"
    },
    {
      question: "¿Qué fotos utilizaréis en mi web?",
      answer: "Para conseguir los mejores resultados, tienes estas opciones para las imágenes de tu web: 1) Imágenes propias: Si tienes fotografías profesionales de tus trabajos, las optimizaremos y utilizaremos como contenido principal; 2) Sesión fotográfica: Podemos recomendarte fotógrafos especializados en peluquería en varias ciudades (presupuesto aproximado: 150-250€ por sesión); 3) Imágenes mixtas: Combinación de tus mejores fotos actuales (incluso de smartphone) con algunas imágenes de stock seleccionadas; 4) Formación fotográfica: Te ofrecemos una guía para que aprendas a tomar mejores fotos de tus trabajos con el móvil. Las imágenes son cruciales en el sector de la peluquería, por lo que recomendamos invertir en buenas fotografías. Si no dispones inicialmente de material fotográfico profesional, podemos comenzar con una combinación de tus mejores fotos actuales e imágenes de stock, e ir actualizando la web a medida que generes nuevo contenido visual de calidad.",
      category: "Contenidos"
    },
    {
      question: "¿Cómo funcionará el mantenimiento de la web?",
      answer: "El mantenimiento mensual de 20€ incluye: 1) Alojamiento en servidores de alta velocidad; 2) Renovación anual del dominio; 3) Certificado de seguridad SSL; 4) Copias de seguridad diarias; 5) Actualizaciones de seguridad y del sistema; 6) Soporte técnico por email y teléfono; 7) Pequeñas modificaciones de contenido (hasta 30 minutos mensuales); 8) Monitorización de rendimiento. Te proporcionamos acceso a un panel intuitivo donde podrás: actualizar la galería con nuevos trabajos, modificar precios o servicios, añadir entradas al blog, y actualizar información básica. Para peluquerías, incluimos una formación específica para que puedas mantener actualizada tu galería de trabajos desde el móvil de forma sencilla. Si necesitas modificaciones mayores, disponemos de tarifas especiales para clientes de mantenimiento. El mantenimiento es obligatorio para garantizar el correcto funcionamiento de la web, asegurar la renovación del dominio y el alojamiento seguro de los contenidos.",
      category: "Mantenimiento"
    }
  ];

  return (
    <HostingerStyleServiceTemplate
      // SEO optimizado para peluquerías
      pageTitle="Web para Peluquerías desde 200€ | Presencia Online Profesional"
      pageDescription="Diseño web especializado para peluquerías y salones de belleza. Catálogo de servicios, galería de trabajos y presencia local para captar más clientes en tu zona."
      pageKeywords="página web barata peluquería, web para peluquerías, diseño web salón belleza, página web peluquería barata, web peluquería económica"
      canonicalUrl="https://webabajocoste.es/servicios/diseno-web-peluqueria"
      
      // Hero adaptado al buyer persona
      heroTitle="Web para peluquerías desde 200€ (atrae clientes mientras cortas)"
      heroSubtitle="Diseño web profesional para peluquerías. Muestra tus trabajos, servicios y precios. Optimizada para atraer clientes de tu zona."
      heroImage="/servicios/tipo-cliente/hero-peluqueria.webp"
      badges={['Desde 200€ (pago único)', 'Galería de trabajos', 'Sistema de citas', 'Mantenimiento 20€/mes']}
      heroCTAText="Solicitar presupuesto gratuito"
      heroCTALink="/reserva"
      
      // Secciones adaptadas
      pricingTitle="Planes para peluquerías y salones"
      pricingSubtitle="Elige el plan que mejor se adapte a tus necesidades. Todos incluyen soporte técnico y mantenimiento por 20€/mes. *Sistemas de citas online presupuestados aparte."
      plans={plans}
      
      featuresTitle="¿Por qué nuestra web es ideal para peluquerías?"
      features={features}
      
      // Componente FounderInsight insertado como contenido personalizado
      customContent={
        <FounderInsight 
          insightText={founderMessage}
          founderName="Jaime Vela"
          founderTitle="Co-fundador y Director de Marketing"
          avatarSrc="/sobre nosotros/foto-jaime.webp"
        />
      }
      
      processTitle="Creamos tu web en 3 sencillos pasos"
      processSteps={processSteps}
      
      comparisonTitle="¿Por qué elegirnos para tu web de peluquería?"
      comparisonItems={comparisonItems}
      
      testimonial={testimonial}
      
      benefitsTitle="Ventajas de una web profesional para tu peluquería"
      benefits={benefits}
      
      faqTitle="Preguntas frecuentes sobre webs para peluquerías"
      faqCategories={["Beneficios", "Contenidos", "Funcionalidades", "Planes", "Mantenimiento"]}
      faqs={faqs}
      
      ctaTitle="Impulsa tu peluquería con presencia online profesional"
      ctaDescription="Una inversión inteligente que atraerá nuevos clientes, mostrará tu talento y diferenciará tu salón de la competencia. Recupera la inversión en pocas semanas."
      ctaButtonText="Solicitar presupuesto gratuito"
      ctaButtonLink="/reserva"
      
      relatedLinks={relatedLinks}
    />
  );
};

export default WebPeluqueriaPage; 

